import { load } from "./events/load";
import { clickOn } from "./events/click";

load(() => {
	clickOn("[href^='tel:'], [href^='tel:'] *", (e) => {
		fbq('track', 'Contact');
	});
})
document.addEventListener("formSended", () => {
	if(sessionStorage.getItem('formSended')) return;
	sessionStorage.setItem('formSended', true);
	fbq('track', 'Lead');
})